// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8b28815f","453":"c108aea8","455":"e8485c43"}[chunkId] + ".chunk.js";
};